import Service from './baseService';
import { getModelTypeIdAndEntityId } from '../config';

export const getTripsByDateService = (date) => {
    return Service.get('/customer/trips-by-date', { params: { date, ...getModelTypeIdAndEntityId() } });
};
